export default __webpack_public_path__ + "static/media/photo--sm--kickoff-group.f4db6a8a.jpg";